function SliderSettings(length) {
  return {
    "dots": true,
    "arrows": true,
    "infinite": false,
    "speed": 500,
    "slidesToShow": length > 4 ? 4 : length,
    "slidesToScroll": length > 4 ? 4 : length,
    "initialSlide": 0,
    "responsive": [
      {
        "breakpoint": 1024,
        "settings": {
          "slidesToShow": length > 3 ? 3 : length,
          "slidesToScroll": length > 3 ? 3 : length,
          "infinite": false,
          "dots": true
        }
      },
      {
        "breakpoint": 600,
        "settings": {
          "slidesToShow": length > 2 ? 2 : length,
          "slidesToScroll": length > 2 ? 2 : length,
          "initialSlide": length > 2 ? 2 : length,
        }
      },
      {
        "breakpoint": 480,
        "settings": {
          "slidesToShow": 1,
          "slidesToScroll": 1,
          "dots": true,
        }
      }
    ]
  }
}

function SliderSettingsProduct(length) {
  return {
    "dots": true,
    "arrows": true,
    "infinite": false,
    "speed": 500,
    "slidesToShow": length > 4 ? 4 : length,
    "slidesToScroll": length > 4 ? 4 : length,
    "initialSlide": 0,
    "responsive": [
      {
        "breakpoint": 1434,
        "settings": {
          "slidesToShow": length > 3 ? 3 : length,
          "slidesToScroll": length > 3 ? 3 : length,
          "infinite": false,
          "dots": true
        }
      },
      {
        "breakpoint": 600,
        "settings": {
          "slidesToShow": length > 2 ? 2 : length,
          "slidesToScroll": length > 2 ? 2 : length,
          "initialSlide": length > 2 ? 2 : length,
        }
      },
      {
        "breakpoint": 480,
        "settings": {
          "slidesToShow": 1,
          "slidesToScroll": 1,
          "dots": true,
        }
      }
    ]
  }
}

function SliderSettingsProductCustomize(length) {
  return {
    "dots": length > 16 ? false : true,
    "arrows": true,
    "infinite": false,
    "speed": 500,
    "slidesToShow": length > 4 ? 4 : length,
    "slidesToScroll": length > 4 ? 4 : length,
    "initialSlide": 0,
    "responsive": [
      {
        "breakpoint": 1024,
        "settings": {
          "slidesToShow": length > 3 ? 3 : length,
          "slidesToScroll": length > 3 ? 3 : length,
          "infinite": false,
          "dots": length > 16 ? false : true
        }
      },
      {
        "breakpoint": 600,
        "settings": {
          "slidesToShow": length > 2 ? 2 : length,
          "slidesToScroll": length > 2 ? 2 : length,
          "initialSlide": length > 2 ? 2 : length,
        }
      },
      {
        "breakpoint": 480,
        "settings": {
          "slidesToShow": 2,
          "slidesToScroll": 1,
          "dots": length > 16 ? false : true,
        }
      }
    ]
  }
}


export {
  SliderSettings,
  SliderSettingsProduct,
  SliderSettingsProductCustomize
}



// WEBPACK FOOTER //
// ./src/components/order/SliderSettings.js